import React from 'react';
import { ItemPath } from '../../../../order.schema';
import FinalProductIdentificationSection from '../../ItemTypes/Product/FinalProductIdentificationSection';
import FinalProductSection from '../../ItemTypes/Product/FinalProductSection';

interface FormProductProps {
  itemPath: ItemPath;
}

export const FormProduct: React.FC<FormProductProps> = ({ itemPath }) => {
  return (
    <>
      <FinalProductIdentificationSection itemPath={itemPath} />
      <FinalProductSection itemPath={itemPath} />
    </>
  );
};